<template>
  <div class="skytop">
    <div class="skyhead"></div>
    <div class="skyheadcd">
      <div class="cdbt"><a href="#" @click="toIndex()">首页</a></div>
      <div class="cdbt"><a href="#" @click="toHtml('dwjj')">单位简介</a></div>
<!--      <div class="cdbt"><a href="#" @click="toHtml('zzjgorglist')">组织机构</a></div>-->
<!--      <div class="cdbt"><a href="#" @click="toHtml('cgzs')">成果展示</a></div>-->
<!--      <div class="cdbt"><a href="#" @click="toClsList(159)">学术交流</a></div>-->
<!--      <div class="cdbt"><a href="#" @click="toHtml('xrld')">现任领导</a></div>-->
<!--      <div class="cdbt"><a href="#" @click="toHtml('zjfc')">专家风采</a></div>-->
      <div class="cdbt"><a href="#" @click="toHtml('dqtd')">党群天地</a></div>
      <div class="oaanys" v-if="islan"><a href="http://10.44.47.5/oa/"><img src="../assets/images/oaan.png"/></a></div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "menuTop",
        props:['islan'],
        methods:{
            toIndex(){
                this.$parent.changeIndex();
            },
            toClsList(id){
                this.$parent.changeClsList(id);
            },
            toHtml(com){
                this.$parent.changeHtml(com);
            }
        }
    }
</script>

<style scoped>
@import '../assets/css/head.css';
</style>



// WEBPACK FOOTER //
// src/components/menuTop.vue